// extracted by mini-css-extract-plugin
export default {"wallpaper_page":"Index_wallpaper_page__vVP+W"};